import { Controller } from "@hotwired/stimulus"

// Copies the source element's text and confirms on the button.
export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    const text = this.sourceTarget.value ?? this.sourceTarget.textContent
    try {
      await navigator.clipboard.writeText(text)
    } catch {
      this.sourceTarget.select?.()
      document.execCommand("copy")
    }
    const label = this.buttonTarget.textContent
    this.buttonTarget.textContent = "Copied!"
    setTimeout(() => { this.buttonTarget.textContent = label }, 1500)
  }
}
